import React, { ChangeEventHandler, FormEventHandler } from 'react';

import { Button, GridLegacy as Grid, TextField } from '@mui/material';

type Props = {
  searchString: string;
  handleChange: ChangeEventHandler<HTMLInputElement>;
  handleSubmit: FormEventHandler<HTMLFormElement>;
};

export default function BlacklistedOfferSearchForm({ searchString, handleChange, handleSubmit }: Props) {
  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <TextField
            id="BlacklistedOfferSearch"
            data-testid="BlacklistedOfferSearch"
            type="text"
            name="searchString"
            label="Offer ID"
            placeholder="Enter Offer ID"
            value={searchString}
            onChange={handleChange}
            autoFocus
            fullWidth
          />
        </Grid>
        <Grid item xs={4}>
          <Button type="submit" variant="contained" className="T-search-user">
            Search
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
